<template>
  <div class="news_details_wrap news-detail-page">
    <PCNavbar selectIndex="4-2"/>
    <MobileNavBar :currentActive="3"/>
    <div class="news_content">
      <el-breadcrumb class="news_bread" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>

      <article class="news_article">
        <header class="news_article_header">
          <h1 class="news_title">
            喜讯｜我司再获三件实用新型专利
          </h1>
          <div class="news_meta">
            <span class="news_meta_item">来源：山东智能工业装备公司</span>
            <span class="news_meta_sep">·</span>
            <span class="news_meta_item">投稿时间：2026-10-21</span>
          </div>
        </header>

        <div class="article_body">
          <p class="lead">
            近日，我司再获三件实用新型专利。三件专利分别面向新能源汽车充电连接、室外充电桩便捷拆装及电动自行车补能场景，为公司充电装备产品研发与项目落地再添知识产权支撑。
          </p>

          <h2 class="section_title">一、专利概况</h2>

          <p class="body_paragraph">
            本次取得的三件实用新型专利具体如下：
          </p>

          <p class="body_paragraph">
            1. 《一种用于连接新能源汽车充电的充电设备》，专利号 ZL202221981033.5，聚焦新能源汽车充电过程中的连接结构与使用便利性；
          </p>

          <p class="body_paragraph">
            2. 《一种便于拆装的室外用新能源充电桩》，专利号 ZL202222107107.9，面向室外场景，注重设备拆装效率与运维便利；
          </p>

          <p class="body_paragraph">
            3. 《用于电动自行车的充电桩》，专利号 ZL202322133535.3，服务二轮电动自行车有序停放与绿色补能需求。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.patent1"
              alt="一种用于连接新能源汽车充电的充电设备 专利登记簿副本"
            >
            <figcaption class="figure_caption">
              《一种用于连接新能源汽车充电的充电设备》专利登记簿副本
            </figcaption>
          </figure>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.patent2"
              alt="一种便于拆装的室外用新能源充电桩 手续合格通知书"
            >
            <figcaption class="figure_caption">
              《一种便于拆装的室外用新能源充电桩》手续合格通知书
            </figcaption>
          </figure>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.patent3"
              alt="用于电动自行车的充电桩 专利登记簿副本"
            >
            <figcaption class="figure_caption">
              《用于电动自行车的充电桩》专利登记簿副本
            </figcaption>
          </figure>

          <h2 class="section_title">二、意义与价值</h2>

          <p class="body_paragraph">
            上述专利覆盖四轮与二轮充电应用，与公司「鲸王」产品体系及场站建设实践相互呼应，有助于提升设备安装效率、增强不同场景下的适配能力，为公共充电站、交通枢纽、商圈园区及非机动车停放点等项目提供更有力的技术保障。
          </p>

          <p class="body_paragraph">
            此次专利取得，既是公司长期坚持技术创新与成果转化的阶段性体现，也进一步丰富了知识产权储备，为后续产品迭代、项目交付和对外合作夯实基础。
          </p>

          <h2 class="section_title">三、下一步工作</h2>

          <p class="body_paragraph">
            下一步，我司将持续加大研发投入，完善专利布局与质量管理体系，推动更多创新成果转化为可落地、可推广的充电产品与解决方案，携手客户与合作伙伴共建安全、高效、智能的充电基础设施，为新能源汽车产业高质量发展贡献力量。
          </p>
        </div>
      </article>
    </div>

    <div class="news_detail_page_foot">
      <CallMe/>
      <MobileCallme/>
    </div>
  </div>
</template>

<script>
import PCNavbar from '@/components/report_list/SpaNav.vue'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CallMe,
    MobileCallme,
  },
  data () {
    return {
      images: {
        patent1: require('@/assets/images/news-list/news12/patent1.jpg'),
        patent2: require('@/assets/images/news-list/news12/patent2.jpg'),
        patent3: require('@/assets/images/news-list/news12/patent3.jpg'),
      },
    }
  },
}
</script>

<style lang="scss">
@import '~@/assets/styles/news-detail-responsive.scss';
</style>
